import { STATIC_FAQ } from "./staticFaq";

class MessageParser {
  constructor(actionProvider) {
    this.actionProvider = actionProvider;
  }

  parse = (message) => {
    const normalizedMessage = (message || "").toLowerCase().trim();

    if (!normalizedMessage) {
      this.actionProvider.handleUnknownQuestion();
      return;
    }

    const matchedFaq = STATIC_FAQ.find((faq) =>
      faq.keywords.some((keyword) => normalizedMessage.includes(keyword)),
    );

    if (matchedFaq) {
      this.actionProvider.handleFaqSelection(matchedFaq.id);
      return;
    }

    this.actionProvider.handleUnknownQuestion();
  };
}

export default MessageParser;
